
<div class="amplify-container" *ngIf="_show">
<div class="amplify-form-container" data-test="confirm-sign-up-section">
  <div class="amplify-form-body" data-test="confirm-sign-up-body-section">
    <div
      class="amplify-form-header"
      data-test="confirm-sign-up-header-section"
    >
      {{ this.amplifyService.i18n().get('Confirm Sign up') }}</div>
    <div class="amplify-form-row">
      <label class="amplify-input-label" for="amplifyUsername">
        {{ this.amplifyService.i18n().get(getUsernameLabel()) }}
      </label>
      <input
        #amplifyUsername
        class="amplify-form-input"
        type="text"
        disabled
        placeholder="{{ this.amplifyService.i18n().get(getUsernameLabel()) }}"
        [value]="username"
        data-test="confirm-sign-up-username-input"
      />
    </div>
    <div class="amplify-form-row">
      <label class="amplify-input-label" for="code">
        {{ this.amplifyService.i18n().get('Confirmation Code *') }}
      </label>
      <input #code
        (change)="setCode(code.value)"
        (keyup)="setCode(code.value)"
        (keyup.enter)="onConfirm()"
        class="amplify-form-input"
        type="text"
        placeholder="{{ this.amplifyService.i18n().get('Enter your Code') }}"
        data-test="confirm-sign-up-confirmation-code-input"
      />
      <span class="amplify-form-action">{{ this.amplifyService.i18n().get('Lost your code?') }}
        <a class="amplify-form-link"
            (click)="onResend()"
            data-test="confirm-sign-up-resend-code-link"
          >{{ this.amplifyService.i18n().get('Resend Code') }}</a></span>
    </div>
    <div class="amplify-form-actions">
      <div class="amplify-form-cell-left">
        <div class="amplify-form-actions-left">
          <a
            class="amplify-form-link"
            (click)="onSignIn()"
            data-test="confirm-sign-up-back-to-sign-in-link"
            >
            {{ this.amplifyService.i18n().get('Back to Sign in') }}
          </a>
        </div>
      </div>
      <div class="amplify-form-cell-right">
        <button
          class="amplify-form-button"
          (click)="onConfirm()"
          data-test="confirm-sign-up-confirm-button"
          >{{ this.amplifyService.i18n().get('Confirm') }}</button>
      </div>
    </div>
  </div>
</div>
<div class="amplify-alert" *ngIf="errorMessage">
  <div class="amplify-alert-body">
    <span class="amplify-alert-icon">&#9888;</span>
    <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
    <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
  </div>
</div>
</div>
